import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectCard as ProjectCardType } from '../../types/dashboard';
import { IconHistory, IconCheckupList, IconArrowRight } from '@tabler/icons-react';
import styles from './DashboardCards.module.scss';

interface ProjectCardProps {
  data: ProjectCardType;
  onClick?: () => void;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ data, onClick }) => {
  const { t } = useTranslation('dashboard');
  const Icon = data.type === 'common' ? IconHistory : IconCheckupList;
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <div className={styles.summaryCard} onClick={onClick}>
      <div className={styles.cardHeader}>
        <div className={styles.cardTitle}>
          <Icon />
          <span>{data.type === 'last' ? t('projectCard.lastProject') : t('projectCard.commonlyUsed')}</span>
        </div>
        <span className={styles.lastEdit}>{t('projectCard.lastEdit', { date: formatDate(data.lastEditDate) })}</span>
      </div>
      <div className={styles.cardContent}>
        <img src={data.logoUrl} alt="Project Logo" className={styles.projectLogo} />
        <span className={styles.projectName}>{data.title}</span>
        <div className={styles.avatarGroup}>
          {data.teamMembers.slice(0, 3).map((member) => (
            <img 
              key={member.id} 
              src={member.avatarUrl} 
              alt={member.name} 
              title={member.name}
            />
          ))}
          {data.teamMembers.length > 3 && (
            <div className={styles.avatarMore}>
              +{data.teamMembers.length - 3}
            </div>
          )}
        </div>
        <IconArrowRight color='#898989' />
      </div>
    </div>
  );
};

export default ProjectCard; 